import { SourceHandlerMap, SourceName } from "../types";

import { getFirstOrderHandler } from "./get-first-order";
import { getPostCheckoutChargesHandler } from "./get-post-checkout-charges";

export const SOURCE_HANDLERS: SourceHandlerMap = {
  [SourceName.GET_FIRST_ORDER]: getFirstOrderHandler,
  [SourceName.GET_POST_CHECKOUT_CHARGES]: getPostCheckoutChargesHandler,
};
